import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from "react-query";
import { updateReminder } from "@/services/tasks";
import { useSelectedPatientStore } from "@/stores/selected-patient";

/** Mutation hook for updating an existing patient reminder. Updates the local store on success. */
export function useUpdateReminder(patientUid) {
  return useMutation(function (_ref) {
    var reminderId = _ref.reminderId,
      payload = _ref.payload;
    if (!patientUid) throw new Error("patientUid is required");
    return updateReminder(patientUid, reminderId, payload);
  }, {
    onSuccess: function onSuccess(updatedReminder) {
      var _selectedPatient$remi;
      var _useSelectedPatientSt = useSelectedPatientStore.getState(),
        selectedPatient = _useSelectedPatientSt.selectedPatient,
        setSelectedPatient = _useSelectedPatientSt.setSelectedPatient;
      if (!selectedPatient) return;
      var updatedReminders = ((_selectedPatient$remi = selectedPatient.reminders) !== null && _selectedPatient$remi !== void 0 ? _selectedPatient$remi : []).map(function (r) {
        return r.id === updatedReminder.id ? updatedReminder : r;
      });
      setSelectedPatient(_objectSpread(_objectSpread({}, selectedPatient), {}, {
        reminders: updatedReminders
      }));
    }
  });
}